import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { connect } from 'react-redux';
import { MODAL_QUESTION_MULTY_FORM, showModal } from '../../../../modules/modals';
import './style.scss';
import Item from './components/Item/Item'
import { List } from 'antd';
import { Pagination } from 'antd';
import {cloneDeep, difference, isEqual} from 'lodash';
import Spiner from '../../../helpers/Spiner/Spiner';

export class Questions extends Component {
  static contextTypes = {formatMessage: PropTypes.any};

  constructor(props) {
		super(props)
		this.state = {
			questions_data: props.questions,
			pageSize: 10,
			currentPage: 1,
			questions: this.paginate(props.questions, 10, 1),
		}

		this.refEndEl = React.createRef();
	}

  scrollToBottom = () => {
		if(this.refEndEl.current){
			this.refEndEl.current.scrollIntoView({ behavior: "smooth" });
		}
	}

	componentDidMount(){
		window.goToLastPage = this.goToLastPage;
	}

	goToLastPage = () => {
		let {currentPage} = this.state;
		currentPage = Math.ceil(this.props.questions.length/this.state.pageSize);
		this.setState({
			questions_data: this.props.questions,
			questions: this.paginate(this.props.questions, this.state.pageSize, currentPage),
			currentPage
		});
		this.scrollToBottom();
	}


	componentWillReceiveProps(nextProps){

		const newIds = nextProps.questions.map(i => i.id);
		const oldIds = this.state.questions_data.map(i => i.id);
		let {currentPage} = this.state;
    if(!isEqual(newIds, oldIds)){
      console.log('test+++')
      this.setState({
        questions_data: nextProps.questions,
        questions: this.paginate(nextProps.questions, this.state.pageSize, currentPage),
      })
    } else {
      this.setState({
        questions_data: nextProps.questions,
        questions: this.state.questions.map(_i => {
          const find = nextProps.questions.find(_f => _i.id == _f.id);
          return find ? {...find} : {..._i}
        })
      })
    }
	}

	onShowSizeChange = (current, pageSize) => {
		this.setState({
			questions: this.paginate(this.state.questions_data, pageSize, current),
			pageSize,
			currentPage: current
		})
	}

	paginate = (array, page_size, page_number) => {
		if(page_number == 0){
			return cloneDeep(array).slice(0, page_size);
		}
  	--page_number;
		return cloneDeep(array).slice(page_number * page_size, (page_number + 1) * page_size);
	}

	scrollToTop(scrollDuration) {
    var scrollStep = -window.scrollY / (scrollDuration / 15),
        scrollInterval = setInterval(function(){
        if ( window.scrollY != 0 ) {
            window.scrollBy( 0, scrollStep );
        }
        else clearInterval(scrollInterval); 
    },15);
	}

  render() {
    const {formatMessage} = this.context;
    const {loaded, subject_selcted, category_selcted} = this.props;
    const {questions, questions_data, pageSize, currentPage } = this.state;
    const disabled = !(Boolean(subject_selcted) && Boolean(category_selcted));
    return (
      <div className='question-container QuestionsBlock'>
        <div className="question-types-block">
            <div
                onClick={() => {
                  if(!Boolean(subject_selcted)){
                    return;
                  }
                  const { showModal } = this.props;
                  showModal({
                    modalType : MODAL_QUESTION_MULTY_FORM,
                    modalProps : {
                      initialValues: {
                        subject_id: subject_selcted ? subject_selcted.id : '',
                        category_id: category_selcted ? category_selcted.id : '',
                        is_show: true,
                        question_type: 'type1'
                      }
                    }
                  });
                }}
                className={cn("question-type", {disabled })}
            >
                <span className="question-type-plus-icon">+</span> {formatMessage("ADD_QUESTION")}
            </div>
        </div>
        <div className='block'>
          {!loaded && <div className='spinner'>
            <Spiner/>            
          </div>}
          {questions.length > 0 && <Pagination
            style={{marginTop: 20}}
            showSizeChanger
            onShowSizeChange={this.onShowSizeChange}
            total={questions_data.length}
            pageSizeOptions={['5', '10', '20', '50']}
            pageSize={pageSize}
            current={currentPage}
            onChange={(page, pageSize) => {
                
              this.setState({
                questions: this.paginate(this.state.questions_data, pageSize, page),
                pageSize,
                currentPage: page,
              }, () => {
                this.scrollToTop(500);
              })
            }}
          />}
            {questions.map((question, index) => <Item key={'item-question-'+ question.id} indexEl={index} item={question} items={questions_data} />)}
            {questions.length > 0 && <Pagination
              style={{marginTop: 20, marginBottom: 20}}
              showSizeChanger
              onShowSizeChange={this.onShowSizeChange}
              total={questions_data.length}
              pageSizeOptions={['5', '10', '20', '50']}
              pageSize={pageSize}
              current={currentPage}
              onChange={(page, pageSize) => {
                  
                this.setState({
                  questions: this.paginate(this.state.questions_data, pageSize, page),
                  pageSize,
                  currentPage: page,
                }, () => {
                  this.scrollToTop(500);
                })
              }}
            />}
						 <div style={{ float:"left", clear: "both" }}
							ref={this.refEndEl}>
						</div>
          {/* <List
            renderItem={(item) => <Item key={'question-' + item.id} item={item} />}
            dataSource={questions.map(_i => ({..._i, key: _i.id}))}
            loading={!loaded}
            pagination={{
              pageSizeOptions: ['5', '10', '20', '50'],
            }}
          /> */}
          {/* {questions.map(item => )} */}
        </div>
        {questions.length > 0 && <div className="question-types-block">
            <div
                onClick={() => {
                  if(!Boolean(subject_selcted)){
                    return;
                  }
                  const { showModal } = this.props;
                  showModal({
                    modalType : MODAL_QUESTION_MULTY_FORM,
                    modalProps : {
                      initialValues: {
                        subject_id: subject_selcted ? subject_selcted.id : '',
                        category_id: category_selcted ? category_selcted.id : '',
                        is_show: true,
                        question_type: 'type1'
                      }
                    }
                  });
                }}
                className={cn("question-type", {disabled : !Boolean(subject_selcted)})}
            >
                <span className="question-type-plus-icon">+</span> {formatMessage("ADD_QUESTION")}
            </div>
        </div>}
      </div>
    )
  }
}



const mapStateToProps = (state, ownProps) => ({
  questions: state.question.list,
  loaded: state.question.loaded,
  subject_selcted: state.question.subject_selcted,
  category_selcted: state.question.category_selcted,
})

const mapDispatchToProps = {
  showModal,
}

export default connect(mapStateToProps, mapDispatchToProps)(Questions)




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/components/Questions/Questions.jsx